import appStore from 'store';
import api from './api';
import { STATUS_TYPES } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    ballot: [],
    totalCount: 0,
    editingProject: null,
    editingContentProject: null,
    pagination: {
      page: 1,
      size: 25
    },
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: item.toString(),
        label: LANGUAGE[item]
      };
    }),
    relativePrice: []
  },
  getters: {
    projectList: state =>
      state.projects.map(item => ({
        ...item,
        __status: STATUS_TYPES[item.status]
      }))
  },
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    },
    setEditingContentProject(state, payload) {
      state.editingContentProject = payload;
    },
    setPrice(state, payload) {
      state.relativePrice = payload;
    },
    setBallot(state, payload) {
      state.ballot = payload;
      // state.totalCount = payload.totalCount;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    },
    update(context, data) {
      return api.update(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    getPurchaseLanguageContent(content, data) {
      return api.getPurchaseLanguageContent(data);
    },
    updateContent(context, data) {
      return api.updateContent(data);
    },
    getRelativePrice({ commit }, data) {
      return api.getRelativePrice(data).then(({ data }) => {
        commit('setPrice', data);
      });
    },
    setOpenPrice(context, data) {
      return api.setOpenPrice(data);
    },
    getOneButton(context, data) {
      return api.getOneButton(data);
    },
    getSomeButton(context, data) {
      return api.getSomeButton(data);
    },
    setOneButton(context, data) {
      return api.setOneButton(data);
    },
    setSomeButton(context, data) {
      return api.setSomeButton(data);
    },
    getDayOfAmount(context, data) {
      return api.getDayOfAmount(data);
    },
    setDayOfAmount(context, data) {
      return api.setDayOfAmount(data);
    },
    Addpeople(context, data) {
      return api.Addpeople(data);
    },
    getaward({ commit }, data) {
      return api.getaward(data).then(({ data }) => {
        commit('setBallot', data);
      });
    },
    confirmGitNum(context, data) {
      return api.confirmGitNum(data);
    },
    confirmOne(context, data) {
      return api.confirmOne(data);
    },
    confirconfirmMoremGitNum(context, data) {
      return api.confirmMore(data);
    }
  }
};

appStore.registerModule('discount', store);
